@for (msg of messages; track getIdentifierForIterableItem($index, msg)) {
<acs-alert
  class="alert"
  [type]="msg.messageType"
  (close)="closeAlert($event)"
  [closable]="msg.closable"
  [message]="msg.title"
  role="alert"
></acs-alert>
}
